import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'manufacturer',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `manufacturer`,
    method: 'get',
    params: queriesParams
  })
}

export function addManufacturer (manufacturer) {
  return request({
    method: 'post',
    url: 'manufacturer',
    data: manufacturer
  })
}

export function show (id) {
  return request({
    url: `manufacturer/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `manufacturer/${id}`,
    method: 'patch',
    data
  })
}
